import { useTranslation } from 'react-i18next';

import UniversalButton from "components/uiComponents/UniversalButton";
import { ReactComponent as PlusCircleIcon } from "../../../../static/icons/plus-circle.svg";
import "./SidebarTabsContent.scss";
import useSetting from "components/sidebarComponents/SidebarProject/use-settings";
import { ItemsTypeEnum } from "store/reducers/viewerReducer";
import SettingsItem from "components/sidebarComponents/SettingItem/SettingItem";

const ConditionColorContent = () => {
  const { t } = useTranslation();

  const { settingsItems, addColorItemHandler, temporarySetting, deleteItemsHandler } = useSetting();

  const colorSettingsItems = settingsItems.colors;
  const columnId = temporarySetting.metaData.name

  const deleteSettingHandler = (filterId) => {
    deleteItemsHandler(filterId, ItemsTypeEnum.colors)
  };

  const addNewSettingHandler = () => {
    addColorItemHandler()
  };

  return (
    <div className="color-content">
      <div className="items-wrapper">
        {colorSettingsItems
          ? colorSettingsItems.map((colorSettingItem, index) => {
            return (
              <SettingsItem
                key={colorSettingItem.id}
                id={colorSettingItem.id}
                settingType={ItemsTypeEnum.colors}
                columnId={columnId}
                currentColor={colorSettingItem.color}
                currentOption={colorSettingItem.selectedOption}
                inputsDataArray={colorSettingItem.inputsDataArray}
                deleteItemCallback={deleteSettingHandler}
                type={ItemsTypeEnum.colors}
                options={colorSettingItem.options}
                withColorPicker
              />
            );
          })
          : null}
      </div>
      <UniversalButton
        leftIcon={<PlusCircleIcon />}
        labelColor="blue"
        onClick={addNewSettingHandler}
        backgroundHoverColor="blue-light"
        backgroundColor="blue"
        isFullWidth
        label={t('add_condition')}
      />
    </div>
  );
};

export default ConditionColorContent;
